import React, { Fragment, useEffect, useState } from "react"
import Layout from "../../../../components/Layout"
import Breadcrumb from "../../../../components/Breadcrumb"
import TitleBlock from "../../../../components/TitleBlock"
import ProfessionalCard from "../../../../components/ProfessionalCard"
import Pagination from "../../../../components/Pagination"
import News from "../../../../components/News"
import defaultImage from "../../../../images/news-logo.jpg"
import getQueryParams from "../../../../commons/getQueryParams"
import { useAxiosClient } from "../../../../Services/UseAxiosClient"

const CommercialDiscountCty = ({ pageContext = {}, params = {} }) => {
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [categories, setCategories] = useState([])
  const [category, setCategory] = useState({})
  const [commercialDiscount, setCommercialDiscount] = useState([])
  const id = pageContext.ctypk || params.ctypk

  const getPage = pageSelected => {
    setCurrentPage(pageSelected)
  }

  // get categories
  const [{ data: listCategories }] = useAxiosClient({
    url: `/agreements/categories/intranet/`,
    method: "GET",
  })

  useEffect(() => {
    if (listCategories && listCategories?.length) {
      setCategories(listCategories)
      setCategory(listCategories.find(i => i.pk === +id))
    }
  }, [listCategories, id])

  // get commercial discount
  const [{ data: commercialDiscountList }] = useAxiosClient({
    url: `/agreements/intranet/?${getQueryParams({
      page: currentPage,
      nitems: 20,
      category: id,
    })}`,
    method: "GET",
  })

  useEffect(() => {
    if (commercialDiscountList) {
      setCommercialDiscount(commercialDiscountList?.items)
      setTotalPages(commercialDiscountList?.total_pages)
    }
  }, [commercialDiscountList, id])
  //

  const path = [
    { label: "Inicio", to: "/" },
    { label: "Descuentos comerciales", to: "/descuentos-comerciales" },
    { label: category.title },
  ]

  const renderCards = () => {
    return categories.map((item, i) => {
      return (
        <ProfessionalCard
          link={`/descuentos-comerciales/${item.pk}/${item.slug}`}
          text={item?.title}
          icon={item?.icon_class}
          key={`professional-card${i}`}
          active={item.pk === +id}
          id={item?.pk}
        />
      )
    })
  }

  const renderNews = () => {
    return (
      commercialDiscount &&
      commercialDiscount.map(item => (
        <News
          text={item?.title}
          date={item?.publication_date}
          image={item?.image || defaultImage}
          className="col-12 col-md-6"
          link={`${item?.pk}`}
        />
      ))
    )
  }

  const renderPagination = () => {
    if (totalPages <= 1) {
      return <div className="LegalFile-content mt-3 row">{renderNews()}</div>
    }

    return (
      <Fragment>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          getPage={getPage}
        />
        <div className="LegalFile-content mt-3 row">{renderNews()}</div>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          getPage={getPage}
        />
      </Fragment>
    )
  }

  return (
    <Layout>
      <div className="CommercialDiscount">
        <Breadcrumb path={path} />
        <TitleBlock title="Descuentos comerciales" icon="far fa-id-card" />
        <span className="CommercialDiscount-text">
          Acuerdos comerciales con diferentes colectivos de interés. Podrán
          beneficiarse de descuentos mostrando la tarjeta de asociado.
        </span>
        <div className="ProfessionalCard">
          <div className="ProfessionalCard-container">
            <div className="row intranet-row">
              {renderCards()}
              <ProfessionalCard
                link="/descuentos-comerciales"
                text="Todos"
                icon="fas fa-layer-group"
              />
            </div>
          </div>
        </div>
        <h3 className="CommercialDiscount-title">Descuentos comerciales:</h3>
        {renderPagination()}
      </div>
    </Layout>
  )
}

export default CommercialDiscountCty
